export class ProgressHarnessController {
  public inProgress = true;
  public beadCount = 10;
  public message = "Loading..";
}
